import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ExternalLink } from "lucide-react";
import { api, fmtDate, mediaUrl } from "../lib/api";
import { useContent } from "../context/SiteContext";
import { Container, PageHero, Empty, Loading } from "../components/site/Common";
import { NewsCard } from "../components/site/Cards";

export function NewsList() {
  const { items } = useContent("news");
  return (
    <>
      <PageHero eyebrow="Latest news" title="News & announcements" text="Official updates from the Thanjavur District Badminton Association." />
      <section className="py-16 bg-slate-50 min-h-[50vh]">
        <Container>
          {!items ? <Loading /> : items.length === 0 ? <Empty>No news yet.</Empty> : (
            <div className="grid gap-6 md:gap-8 md:grid-cols-2 lg:grid-cols-3" data-testid="news-grid">{items.map((n) => <NewsCard key={n.id} item={n} />)}</div>
          )}
        </Container>
      </section>
    </>
  );
}

export function NewsDetail() {
  const { id } = useParams();
  const [n, setN] = useState(undefined);
  useEffect(() => { api.get(`/content/news/${id}`).then((r) => setN(r.data)).catch(() => setN(null)); }, [id]);
  if (n === undefined) return <div className="min-h-screen pt-36" />;
  if (!n) return <div className="min-h-screen pt-36"><Container><Empty>Article not found.</Empty></Container></div>;
  return (
    <article className="pt-32 pb-20 bg-white min-h-screen" data-testid="news-detail">
      <Container className="max-w-3xl">
        <Link to="/news" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 hover:text-blue-700 mb-8" data-testid="news-back-link"><ArrowLeft className="h-4 w-4" /> All news</Link>
        <p className="text-sm text-slate-500"><span className="font-semibold text-blue-700 uppercase tracking-wider">{n.category}</span> · {fmtDate(n.date)}</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0B1F44]" data-testid="news-detail-title">{n.title}</h1>
        <p className="mt-5 text-lg text-slate-600">{n.description}</p>
        {n.image && <img src={mediaUrl(n.image)} alt={n.title} className="mt-8 w-full rounded-2xl aspect-[16/9] object-cover" />}
        <div className="mt-8 text-slate-700 leading-relaxed whitespace-pre-line">{n.content}</div>
        {n.external_link && <a href={n.external_link} target="_blank" rel="noreferrer" className="mt-8 btn-outline" data-testid="news-external-link">Open link <ExternalLink className="h-4 w-4" /></a>}
      </Container>
    </article>
  );
}
